module.exports = __webpack_public_path__ + "static/img/jirou.808b4452.png";